import React, { lazy, Suspense, useState, useEffect } from 'react'
import Loader from '../../../components/FundDetails/Modules/Shared/Loader.jsx'

const FundDetailsContainer = lazy(
  () => import('../../../components/FundDetails/FundDetailsContainer.jsx')
)
const HistoricalData = lazy(
  () => import('../../../components/HistoricalData/HistoricalData.jsx')
)
const FullHoldings = lazy(
  () => import('../../../components/FullHoldings/FullHoldings.jsx')
)

export const ProductDetail = ({ component, page }) => {
  const [parameters, setParameters] = useState({
    layout: null,
  })

  useEffect(() => {
    const _parameters = component.getParameters()
    setParameters({
      layout: _parameters?.layout,
    })
  }, [])

  const renderLayout = () => {
    let View = FundDetailsContainer
    switch (parameters?.layout) {
      case 'HistoricalData':
        View = HistoricalData
        break
      case 'FullHoldings':
        View = FullHoldings
        break
    }
    return <View component={component} page={page} />
  }

  return <Suspense fallback={<Loader />}>{renderLayout()}</Suspense>
}
